var cardData = {
  name: 'card',
  data: [{
    tabsCardTitleOffset: '36%'
  }]
};
export default cardData;